import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.js";
import { Lazyload } from "@fancyapps/ui/dist/carousel/carousel.lazyload.js";
import { Arrows } from "@fancyapps/ui/dist/carousel/carousel.arrows.js";
import { Thumbs } from "@fancyapps/ui/dist/carousel/carousel.thumbs.js";
import { Dots } from "@fancyapps/ui/dist/carousel/carousel.dots.js";
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.js";

const mainBanner = document.querySelector('.main-banner');
if (mainBanner) {

    const mainCarousel = Carousel(mainBanner, {
        slidesPerPage: 1,
        transition: 'tween', // tween/fade
        tween: {
            tension: 150,
            friction: 20,
        },
        infinite: true,
        Autoplay: {
            showProgressbar: false,
            timeout: 6000,
        },
        Dots: {
            dotTpl: "<span data-carousel-go-to=\"%i\"></span>",
        },
        Lazyload: {
            preload: 0,
            showLoading: false,
        }
    }, {
        Lazyload,
        Dots,
        Autoplay
    }).init();
}

const basicCarousels = document.querySelectorAll('.basic-carousel');
basicCarousels.forEach(carousel => {

    Carousel(carousel, {
        slidesPerPage: (basicCarousel) => {
            return (basicCarousel.getTotalSlideDim() > basicCarousel.getViewportDim()) ? 1 : 'auto';
        },
        infinite: false,
        fill: true,
        center: false,
        Lazyload: {
            preload: 0
        },
    }, {
        Lazyload
    }).init();
});

window.BuildDetailGallery = function () {
   
    window.DetailMainCarousel = Carousel(document.getElementById("detail-carousel"), {

        infinite: false,
        Thumbs: {
            type: "classic",
            Carousel: {

                vertical: true,
                center: (ref) => {
                    return ref.getTotalSlideDim() > ref.getViewportDim();
                },
                breakpoints: {
                    "(max-width: 1279px)": {
                        vertical: false,
                        center: true,
                    },
                },
            },
        },
        Lazyload: {
            preload: 0
        },
        on: {
            change: (instance) => {
                let activeSlide = instance.getPage().slides[0].el;
                playVideo(activeSlide);
            },
            ready: (instance) => {
                let activeSlide = instance.getPage().slides[0].el;
                playVideo(activeSlide);
            },
        },

    }, {
        Lazyload,
        Arrows,
        Thumbs
    }).init();
}

function playVideo(activeSlide) {
    let videoUrl = activeSlide.dataset.videoUrl;
    let videoExists = activeSlide.querySelector('.detail-video');
    if (!videoUrl || videoExists) return;

    let title = '';
    let headline = document.querySelector('.detail-headline');
    if (headline) title = headline.innerText;

    const videoElement = `
        <video class="detail-video"
            title="Video: ${title}"
            playsinline="true" autoplay loop muted
            src="${videoUrl}"
            width="680" height="680">
        </video>
    `

    activeSlide.insertAdjacentHTML("afterbegin", videoElement);
}

const typeOf = document.body.getAttribute('data-type');
if (["detail", "cms"].includes(typeOf)) {
    import('@fancyapps/ui').then(({ Fancybox }) => {
        Fancybox.bind("[data-fancybox]", {
            placeFocusBack: false,
            hideScrollbar: false,
            Hash: false,
        });

        Fancybox.bind('[data-run-fancybox=""]', {
            autoFocus: false,
            trapFocus: false,
            placeFocusBack: false,
            groupAll: true,
            hideScrollbar: false
        });
    });
}


